import React, { useState, useEffect, useRef, useCallback } from "react";
import { withRouter } from "react-router";
import { connect, useDispatch, useSelector } from "react-redux"; 

import * as actions from "../../../../store/actions";
import { useInfiniteScroll } from "../../../../utils/pagination";
import SearchBox from "../../../../components/formElements/searchbox/SearchBox";
import PatientList from "./PatientList";


import { getSubscribedConciergeServiceListAction } from "../../../../store/actions/dashboardActions";
import _ from "lodash";


const SubscribedPatientList = ({ tab }) => {
  const [page, setPage] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  
  const loader = useRef(null);
  const dispatch = useDispatch();

  const subscribedPatientList = useSelector(state => state.dashboard.conciergeService?.listing);
  
  useInfiniteScroll(loader, () => {
    setPage(page => page + 1);
  });

  const delayedQuery = useCallback(
    _.debounce((query, tab, currentPage) => {
      dispatch(getSubscribedConciergeServiceListAction(query, tab, currentPage));
    }, 500),
    []
  );

  useEffect(() => {
    if (page > 1) {
      if (subscribedPatientList?.links?.total_pages !== subscribedPatientList?.links?.current) {
        dispatch(getSubscribedConciergeServiceListAction(searchValue, tab, page));
      }
    }
  }, [page])
  
  const handleSearchPatient = (query) => {
    setPage(1);
    setSearchValue(query);
    delayedQuery(query, tab, page);
  };



  return (
    <>
      <div className="row m-0 p-0">
        <div className="col-md-12 m-0 p-0">
          <SearchBox
             value={searchValue}
             onChange={handleSearchPatient}
          />
        </div>
      </div>
      <PatientList tab={tab} search={searchValue}/>
      <div ref={loader}></div>
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  getAllPatientList: (page,searchData)=> dispatch(actions.getAllPatientList(page,searchData)),
});

export default withRouter(
  connect(mapDispatchToProps)(SubscribedPatientList)
);
